import {useContext} from 'react';
import {useParams} from 'react-router-dom';
import {UserAffiliations} from '../../../../../../../components/user-affiliations/user-affiliations';
import {OfficeContext} from '../../../../../../../contexts/office/context';
import {OfficeContextType} from '../../../../../../../contexts/office/types';

export default function SeniorAffiliationsSystemAdministratorOfficeScreen() {
  // Get params
  let {id}: {id?: string} = useParams();

  // Get context
  const officeContext: OfficeContextType = useContext(OfficeContext);

  return (
    <UserAffiliations
      userId={id || ''}
      userName={officeContext.state.userForm?.user.name || ''}
      updateAffiliationType={false}
      removeAffiliation={false}
    />
  );
}
